module.exports = __webpack_public_path__ + "img/sy_njzs@3x.9f7cc1fa.png";